import React, { useEffect, useState } from 'react';
import { Users as UsersIcon, Phone } from 'lucide-react';
import { dealerCustomers, buildImageUrl } from '../../services/dealerApi';
import { formatUtcDate } from '../../utils/formatUtcDate';

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dealerCustomers.list().then((r) => setCustomers(r.customers || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="dealer-customers-page" className="space-y-6">
      <div>
        <span className="text-xs uppercase tracking-[0.2em] text-cyan-400 font-medium">Customers</span>
        <h1 className="mt-1 text-3xl md:text-4xl font-extrabold text-white tracking-tight flex items-center gap-3">
          <UsersIcon className="w-7 h-7 text-cyan-400" /> Your Customers
        </h1>
        <p className="text-slate-400 text-sm mt-1">Auto-populated when you mark cars as sold</p>
      </div>

      {loading ? (
        <div className="text-center py-12 text-slate-400">Loading...</div>
      ) : customers.length === 0 ? (
        <div className="bg-slate-900/40 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-12 text-center">
          <p className="text-slate-400">No customers yet. Mark a car as sold to add one here.</p>
        </div>
      ) : (
        <div className="bg-slate-900/40 backdrop-blur-xl border border-slate-700/50 rounded-2xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-800 text-xs uppercase tracking-wider text-slate-400">
                <th className="text-left p-4">Customer</th>
                <th className="text-left p-4">Mobile</th>
                <th className="text-left p-4">Car</th>
                <th className="text-left p-4">Purchase</th>
                <th className="text-left p-4">RSA</th>
                <th className="text-left p-4">Insurance</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((c) => {
                const photo = c.listing?.photos?.[0]?.enhanced_url || c.listing?.photos?.[0]?.url;
                return (
                  <tr key={c.id} className="border-b border-slate-800/60" data-testid={`customer-row-${c.id}`}>
                    <td className="p-4 font-medium text-white">{c.name || '—'}</td>
                    <td className="p-4">
                      <a href={`tel:${c.mobile}`} className="inline-flex items-center gap-1 text-cyan-400 hover:text-cyan-300">
                        <Phone className="w-3 h-3" /> {c.mobile}
                      </a>
                    </td>
                    <td className="p-4">
                      <div className="flex items-center gap-2">
                        {photo && <img src={buildImageUrl(photo)} alt="" className="w-10 h-10 rounded-lg object-cover" />}
                        <div className="min-w-0">
                          <div className="text-white font-medium truncate">{c.listing?.ai_details?.make || ''} {c.listing?.ai_details?.model || ''}</div>
                          <div className="text-xs text-slate-500">{c.listing?.year || ''}</div>
                        </div>
                      </div>
                    </td>
                    <td className="p-4 text-slate-300">{formatUtcDate(c.purchase_date)}</td>
                    <td className="p-4 capitalize">
                      <span className={`px-2 py-0.5 text-xs rounded-full ${c.rsa_status === 'active' ? 'bg-green-500/20 text-green-300' : 'bg-slate-700/40 text-slate-400'}`}>{c.rsa_status}</span>
                    </td>
                    <td className="p-4 capitalize">
                      <span className={`px-2 py-0.5 text-xs rounded-full ${c.insurance_status === 'active' ? 'bg-green-500/20 text-green-300' : 'bg-slate-700/40 text-slate-400'}`}>{c.insurance_status}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Customers;
